export class areaTenant {
  area: string;
  tenant: string;
}

export const CommissioningWithoutPassConstant: areaTenant[] = [
  // {
  //   area: 'DISTRICTHEAT',
  //   tenant: 'swp'
  // },
  // {
  //   area: 'DISTRICTHEAT',
  //   tenant: 'thn'
  // }
];
